"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipIdentifierSubmissionValidation = void 0;
class MembershipIdentifierSubmissionValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.membership_identifier for existence and correct type.
        if (entity.membership_identifier == undefined)
            return false;
        if (typeof entity.membership_identifier !== "string")
            return false;
        return true;
    }
}
exports.MembershipIdentifierSubmissionValidation = MembershipIdentifierSubmissionValidation;
